var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.313V0H3.437A.935.935 0 002.5.938v18.125c0 .519.418.937.938.937h13.124c.52 0 .938-.418.938-.938V6.25h-5.313a.94.94 0 01-.937-.938zm2.546 8.437H11.25v3.125c0 .346-.28.625-.625.625h-1.25a.625.625 0 01-.625-.625V13.75H6.204a.625.625 0 01-.44-1.068L9.53 8.943a.666.666 0 01.94 0l3.766 3.739a.625.625 0 01-.44 1.068zm3.43-9.648L13.403.273A.937.937 0 0012.738 0H12.5v5h5v-.238a.935.935 0 00-.273-.66z"
  })));
}
export default SvgUploadFile;